import styled from 'styled-components'

export const Wrapper = styled.div`
  > h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 1em 0 0.5em 0;
  }

  ul,
  ol {
    padding: 0 0 0 1em;
    margin: 1.5em 0;

    li:not(:last-child) {
      margin-bottom: 0.5em;
    }
  }
`
